<template>
  <div class="remove-user">
    <h2 class="title">Remove User</h2>

    <div class="confirm-text">
      Remove <span>{{ this.email }}</span> from the
      <span>{{ this.org }}</span> organization
    </div>
    <div class="confirm-text">Confirm by typing "Remove" below</div>

    <div class="input-inset-label">
      <label>Confirm</label>
      <NInput v-model:value="removeConfirmInputValue" placeholder="Remove" />
    </div>

    <div class="error" v-if="removeUserError">{{ removeUserError }}</div>

    <div class="buttons">
      <button class="button white-btn" @click="closeClick" v-if="closeClick">
        Cancel
      </button>
      <button class="button red-btn" @click="removeUser">Remove</button>
    </div>
  </div>
</template>

<script>
import CredentialService from "@/services/CredentialService";
import { NInput } from "naive-ui";

export default {
  name: "RemoveUsersForm",
  components: { NInput },
  props: ["closeClick", "email", "org", "role", "userid"],
  data() {
    return {
      removeUserError: null,
      removeConfirmInputValue: null,
      NODE_ENV: process.env.NODE_ENV,
    };
  },
  methods: {
    removeUser() {
      // error validation
      this.removeUserError = null;
      let errors = [];

      if (
        !this.removeConfirmInputValue ||
        this.removeConfirmInputValue.toLowerCase() !== "remove"
      ) {
        errors.push(`please type "remove" to confirm`);
      }

      if (errors.length > 0) {
        return (this.removeUserError = errors.join(", "));
      }

      // if this is the demo env, stop here and don't actually make any calls
      if (process.env.NODE_ENV === "demo") {
        if (this.closeClick) {
          this.closeClick();
        }
        return;
      }

      CredentialService.call("userroles.delete", {
        userid: this.userid,
        orgid: this.org,
        role: this.role.toLowerCase() === "admin" ? "admin" : "user",
      })
        .then((response) => {
          if (response.error) {
            this.triggerError({
              message: "userroles.delete - error obj returned from api",
              error: response.error,
            });
            return Promise.resolve();
          }

          if (this.closeClick) {
            this.closeClick();
          }
        })
        .catch((error) => {
          this.triggerError({
            message: "userroles.delete - catch",
            error: error,
          });
        });
    },
    triggerError(obj) {
      console.log("%cError", "color: white; background-color: red", obj);
      this.removeUserError = "Error - please try again";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/_helpers.scss";

.remove-user {
  width: 100%;

  .confirm-text {
    color: $navy;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 20px;
    span {
      text-transform: uppercase;
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      color: $red;
    }
    &:last-child {
      margin-bottom: 10px;
    }
  }

  .red-btn {
    background-color: $red;
    color: $white;
    @include hover {
      background-color: $red !important;
    }
  }

  .white-btn {
    margin-right: 16px;
  }

  .small-btn {
    border-radius: 25px;
    margin-bottom: 30px;
  }

  &.widget {
    align-items: flex-start;
  }

  button {
    margin: 20px 0 0 0;
  }

  .buttons {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .error {
    text-align: right;
    width: 100%;
    font-size: 14px;
    color: $red;
    margin-top: 5px;
  }
}
</style>
